import React, { useState, useEffect } from "react";
import SuccessLeftImage from "../../assets/SuccessLeftImage.svg";

interface UpgradeSuccessProps {
  openSuccessPopup: boolean;
  setOpenSuccessPopup: (open: boolean) => void;
  handleClosePopup: () => void;
}

const UpgradeSuccess: React.FC<UpgradeSuccessProps> = ({
  openSuccessPopup,
  handleClosePopup,
}) => {
  const [showMainContent, setShowMainContent] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (openSuccessPopup) {
      timeoutId = setTimeout(() => {
        setShowMainContent(true);
      }, 3800);
    }

    // Added timeout logic with proper cleanup as suggested by Ravi B 31-Dec-24
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [openSuccessPopup]);

  return (
    <div
      className={`fixed z-[9999999999999] inset-0 flex items-center justify-center bg-[#00000080] transition-opacity duration-300 ${
        openSuccessPopup ? "opacity-100 visible" : "opacity-0 invisible"
      }`}
      aria-live="polite"
    >
      <div className="bg-white rounded-[20px] max-w-lg md:max-w-3xl w-full m-4 shadow-lg">
        <div className="flex flex-row items-center min-h-auto md:min-h-[449px]">
          <div
            className={`${
              showMainContent
                ? "hide-success-plan-purchase-gif-animation"
                : "hide-success-plan-purchase-gif-animation-zoom-in"
            }`}
          >
            <iframe
              src="https://lottie.host/embed/b05b501d-a9c4-4d5b-a0e4-7ad3ea49c333/bmsag4UNoU.json"
              frameBorder="0"
              allowFullScreen
              title="Lottie Animation"
              style={{ width: "100%", height: "auto" }}
            ></iframe>
          </div>
          <div
            className={`flex flex-row items-center ${
              showMainContent
                ? "hide-success-plan-purchase-gif-animation-zoom-in"
                : "hide-success-plan-purchase-gif-animation"
            }`}
          >
            <div className="w-1/2 hidden md:block">
              <img
                src={SuccessLeftImage}
                alt="Success Left"
                className="rounded-l-[20px]"
              />
            </div>
            <div className="w-full text-center md:text-left md:w-1/2 p-4">
              <h2 className="text-lg font-bold text-gray-700">
                Now you have access to the <br />
                <span className="text-[#06526d]">Premium plan features</span>
              </h2>
              <p className="mt-2 text-gray-600">
                You have successfully upgraded your account to the Premium plan.
                Now you have access to all the premium features. Enjoy 🎉
              </p>

              <button
                className="mt-2 contained"
                onClick={() => {
                  handleClosePopup();
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeSuccess;
